export default "__VITE_ASSET__Cb381VE1__"